import { Component, OnInit } from '@angular/core';
import { MenuController, NavController } from '@ionic/angular';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  constructor(private navCtrl: NavController, private menuCtrl: MenuController) { }

  ngOnInit() {
  }

  goToPage(page: string) {
    this.menuCtrl.close('menuMain');
    this.navCtrl.navigateForward(page);
  }

  exit(){
    this.goToPage('/login');
    Security.clear();
  }
}
